export enum DisplayIdentifier {
	menu = 'menu',
	main = 'main',
	fullPrice = 'full_price',
	sides = 'sides',
	hot_beverages = 'hot_beverages',
}
